import "./_text-card-slider-styles.scss";

import './text-card-slider';
